import React from 'react';

import { Typography } from '@material-ui/core';
import { Rating } from '@material-ui/lab';
import ctx from 'classnames';

import { AggregateRating } from 'models/app';
import { getStarRating } from '../../utils/helpers';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';

type RatingProps = {
  rating: AggregateRating | number;
  className?: string;
  hideZeroRating?: boolean;
  size: 'small' | 'medium' | 'large';
  bottomMargin?: boolean;
};

export const StarRating: React.FC<RatingProps> = ({
  rating,
  className,
  hideZeroRating = true,
  size,
  bottomMargin,
}) => {
  const starRating = typeof rating === 'number' ? rating : getStarRating(rating);
  const { t } = useTranslation();
  if (!starRating && hideZeroRating) return null;
  let style = {
    marginBottom: bottomMargin ? '.35em' : '',
  };
  return (
    <div className={ctx(styles.flex, styles.starRating, className)} style={style} role='note' aria-label={t('aria.ratings',{starRating:starRating})}   >
      <Rating size={size} value={starRating} precision={0.1} readOnly role='note' aria-label={t('aria.ratings',{starRating:starRating})}/>
      <Typography variant="body2" component="p" color="textSecondary">
        {starRating}
      </Typography>
    </div>
  );
};
